import React from "react";
import { Button, Input, Select, Space } from "antd";
import CollapsibleFilterBar from "../../../../../components/common/CollapsibleFilterBar";

const STATUS_OPTIONS = [
    { label: "全部状态", value: "" },
    { label: "草稿/部分发布", value: "EDITING" },
    { label: "发布完成", value: "FINALIZED" },
    { label: "已归档", value: "ARCHIVED" },
];

const SOURCE_OPTIONS = [
    { label: "全部来源", value: "" },
    { label: "空白航班计划", value: "BLANK" },
    { label: "旧版导入", value: "FROM_V1" },
    { label: "复制航班计划", value: "CLONE" },
];

const ScheduleDraftListFilters = ({
    summaryItems,
    quickSearchInputProps,
    status,
    sourceType,
    onStatusChange,
    onSourceTypeChange,
    onReset,
}) => {
    return (
        <CollapsibleFilterBar
            summaryItems={summaryItems}
            onReset={onReset}
            drawerTitle="航班计划筛选条件"
            quickControls={<Input placeholder="搜索航班计划名称..." style={{ width: 240, height: 26 }} {...quickSearchInputProps} />}
        >
            <Space wrap size={[12, 12]}>
                <Select style={{ width: 180 }} options={STATUS_OPTIONS} value={status || ""} onChange={onStatusChange} />
                <Select style={{ width: 180 }} options={SOURCE_OPTIONS} value={sourceType || ""} onChange={onSourceTypeChange} />
                <Button onClick={onReset}>重置</Button>
            </Space>
        </CollapsibleFilterBar>
    );
};

export default ScheduleDraftListFilters;
